// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Meta from 'vue-meta'
import Service from '@/service/service'
import 'element-ui/lib/theme-chalk/index.css'
// import HeadFoot from '@xes/public-head-foot'
// import '@xes/public-head-foot/dist/GlobalHeadFootComponent/xes-head-foot.css' // 引入样式文件
import XesLoggerSDK from '@xes/xes_fe_log'
import config from './config'
import XesMall from '@xes/xueersi-mall-components'

import {
  Carousel,
  CarouselItem,
  Cascader,
  Pagination,
  Select,
  Option,
  Radio,
  RadioGroup,
  Input,
  Popover,
  Tabs,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Message,
  TabPane,
  Checkbox,
  CheckboxGroup
} from 'element-ui'
import CustomerService from './components/CustomerService'
Vue.config.productionTip = false
Vue.use(XesMall)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Meta)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Cascader)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Radio)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)

// Vue.use(HeadFoot)
// 客服组件
Vue.use(CustomerService)

Vue.prototype.Service = Service
Vue.prototype.$message = Message

Vue.use(XesLoggerSDK, {
        common: {
            eventid: 'web_order'
        },
        network: {
            open: true,
            sample: 1
        },
        clickMsg: {
            open: true
        },
        loadMsg: {
            open: false // 自动展现日志开关
        },
        runtime: {
            open: true,
            sample: 1
        },
        resource: {
            open: true,
            sample: 1
        },
        hashchange: {
            open: true, // hashchange自动展现日志开关
            pvid: 'hash',
            pageuid: { // 展现日志、交互日志pageuid路由映射
                'MyOrders': 'MyOrders', // 首页路由pageuid映射
                'detail': 'detail'
            }
        },
        performance: {
            open: true,
            sample: 1
        },
        vue: {
            errorHandler: true
        },
       trace: {
            open: true
        },
        appid: {
            'ocenter.xueersi.com': {
                'appid': '1004975',
                'appkey': '2146932666f2dc0d2806c8690dae4b75' // 2.0.0版本后删除此字段改为referer鉴权模式，需提前日志中心申请时填入referer信息鉴权
            }
        }
    }
)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./module/order/src/main.js